import { useState } from "react";
import { useLanguage } from "assets/languages";
import TextArea from "components/textArea";
import { isGlovvJp, isKyolook } from "constants/domains/domains";

type TMessageCard = {
  languageTexts: ReturnType<typeof useLanguage>["component"]["modelCard"] &
    ReturnType<typeof useLanguage>["common"];
  application: any;
  handleOpenAppealReels: (params: {
    url: string;
    type: string;
    applicationId: number;
  }) => void;
  type: "CAMPAIGN" | "AMBASSADOR";
  canModifyInfluncerMessage: boolean;
  isInfluencersPage: boolean;
  user: any;
  handleMessageChange : (applicationId: number, message: string) => void;
  messages :{applicantId: number, message: string}[];
};

export const MessageCard = ({
  languageTexts,
  application,
  handleOpenAppealReels,
  type,
  canModifyInfluncerMessage,
  isInfluencersPage,
  user,
  handleMessageChange,
  messages
}: TMessageCard) => {

  const applicationId = application.id;
  const _message = messages.find((item)=>item.applicantId === applicationId)?.message || "";


  const [message, setMessage] = useState( _message ?? "");
  

  const modelType =
    user?.suggestions?.length > 0
      ? languageTexts.message_modal_model_type_suggested
      : languageTexts.message_modal_model_type_normal;

  let transformedUrl = user?.userModel?.appealReelsUrl;

  const instaUserId = user?.userModel?.instaUserId;

  if (isInfluencersPage !== undefined && instaUserId) {
    transformedUrl = `https://instagram.com/${instaUserId}/reels`;
  }

  return (
    <div className="flex-col">
      <div className="flex flex-row">
        <img
          className="h-[70px] w-[70px] object-contain"
          src={user.profileBackgroundUrl}
        />
        <div className="ml-[10px] flex flex-col pt-[3px]">
          <span className="text-base font-bold">
            {user.username}
          </span>

          <span className="text-[12px] text-[black]">
            {modelType} ·{" "}
            {application?.isCommissionAmountIncreased >= 1
              ? languageTexts.increased_commission_amount_applied(
                  application.commissionAmount / 10000,
                  isKyolook() || isGlovvJp()
                    ? languageTexts.currencyUnitJPY
                    : languageTexts.currencyUnitKRW
                )
              : languageTexts.original_commission_amount_applied(
                  application.commissionAmount / 10000,
                  isKyolook() || isGlovvJp()
                    ? languageTexts.currencyUnitJPY
                    : languageTexts.currencyUnitKRW
                )}
          </span>

          <span
            className="cursor-pointer text-[14px] text-[#999999] underline tracking-tighter"
            onClick={() =>
              handleOpenAppealReels({
                url: transformedUrl,
                type,
                applicationId: applicationId,
              })
            }
          >
            {languageTexts.message_modal_representative_reels_view}
          </span>
        </div>
      </div>

      <div className="mt-[10px]">
        <TextArea
          bordered
          key="influencer-message-input"
          placeholder={ canModifyInfluncerMessage ? languageTexts.message_modal_placeholder : languageTexts.message_model_not_input}
          autoResize
          value={message}
          onChangeText={(value: any) => {
            setMessage(value);
            handleMessageChange(applicationId, value);
          }}
          disabled={!canModifyInfluncerMessage}
        />
      </div>
    </div>
  );
};
